// src/refracted Dashboard/ParallaxBackground.js
import React, { useEffect, useRef } from "react";

const ParallaxBackground = () => {
  const starsContainerRef = useRef(null);
  const particlesContainerRef = useRef(null);

  useEffect(() => {
    const createStars = () => {
      const starsContainer = starsContainerRef.current;
      if (!starsContainer) return;
      starsContainer.innerHTML = '';
      const starCount = 400;
      for (let i = 0; i < starCount; i++) {
        const star = document.createElement("div");
        star.className = "star";
        star.style.width = `${Math.random() * 2 + 1}px`;
        star.style.height = `${Math.random() * 2 + 1}px`;
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 300}%`;
        star.style.opacity = `${Math.random() * 0.8 + 0.2}`;
        starsContainer.appendChild(star);
      }
    };

    const createParticles = () => {
      const particlesContainer = particlesContainerRef.current;
      if (!particlesContainer) return;
      particlesContainer.innerHTML = '';
      const particleCount = 30;
      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement("div");
        particle.className = "particle";
        const size = Math.random() * 8 + 2;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        const initialLeft = Math.random() * 100;
        const initialTop = Math.random() * 100;
        particle.style.left = `${initialLeft}%`;
        particle.style.top = `${initialTop}%`;
        particle.style.opacity = `${Math.random() * 0.5 + 0.3}`;
        particle.style.animation = `float ${Math.random() * 15 + 10}s ${Math.random() * 2}s infinite linear`;
        particle.setAttribute('data-parallax-multiplier', Math.random() * 0.3 + 0.1);
        particle.setAttribute('data-initial-left', initialLeft);
        particle.setAttribute('data-initial-top', initialTop);
        particlesContainer.appendChild(particle);
      }
    };

    const handleParallax = () => {
      const scrollPosition = window.scrollY;
      const starsContainer = starsContainerRef.current;
      const particlesContainer = particlesContainerRef.current;
      if (starsContainer) {
        starsContainer.style.transform = `translateY(${scrollPosition * 0.2}px)`;
      }
      if (particlesContainer) {
        const particles = particlesContainer.children;
        for (let particle of particles) {
          const multiplier = parseFloat(particle.getAttribute('data-parallax-multiplier'));
          const parallaxTransform = `translate(0, ${scrollPosition * multiplier}px)`;
          particle.style.transform = parallaxTransform;
        }
      }
    };

    const handleScrollReveal = () => {
      document.querySelectorAll("[data-scroll-reveal]").forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.75 && !el.classList.contains("appear")) {
          el.classList.add("appear");
        }
      });
    };

    createStars();
    createParticles();
    window.addEventListener("scroll", handleScrollReveal);
    window.addEventListener("scroll", handleParallax);

    return () => {
      window.removeEventListener("scroll", handleScrollReveal);
      window.removeEventListener("scroll", handleParallax);
    };
  }, []);

  return (
    <>
      <div className="stars" ref={starsContainerRef} />
      <div className="particles" ref={particlesContainerRef} />
    </>
  );
};

export default ParallaxBackground;